import styled from 'styled-components/macro';
import { row_center_both } from 'src/App/Styles/styles-helpers';

export const HeaderContain = styled.div`
	${row_center_both}
	padding: 0.5em 1em;
	background: #1c1b32;
	font-size: 0.875em;
	svg {
		width: 100px;
		cursor: pointer;
	}
`;
